export const OrganizationsVendorsShippingRuleDataFragment = `
    id
    shipping_cost
    target_total
`
